var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.hasItems
    ? _c(
        "div",
        { staticClass: "d-flex gap-1 flex-wrap" },
        _vm._l(_vm.tags, function (tag) {
          return _c(
            "el-tag",
            { key: tag.id, attrs: { size: "small", type: _vm.type(tag) } },
            [_vm._v("\n    " + _vm._s(tag.title) + "\n  ")]
          )
        }),
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }